export const GOOGLE_STORE_PURCHASE_LOG_LIST_REQUEST = "GOOGLE_STORE_PURCHASE_LOG_LIST_REQUEST";

export const GOOGLE_STORE_PURCHASE_LOG_LIST = "GOOGLE_STORE_PURCHASE_LOG_LIST";

export const SET_TOTAL_COUNT = "SET_TOTAL_COUNT";

export const SET_GOOGLE_STORE_PURCHASE_LOG_PAGINATION = "SET_GOOGLE_STORE_PURCHASE_LOG_PAGINATION";

export const GOOGLE_STORE_PURCHASE_LOG_PAGE_RESET = "GOOGLE_STORE_PURCHASE_LOG_PAGE_RESET";